import { Outlet } from "react-router-dom";
import { UsersProvider } from "../context/UsersContext";

export function UsersProviderWrapper() {
  return (
    <UsersProvider>
      <Outlet />
    </UsersProvider>
  );
}
